<template>
  <el-container class="layout-container">
    <el-aside width="200px" class="sidebar">
      <div class="logo">
        <h3>阳光打印超市</h3>
      </div>
      <el-menu
        :default-active="activeMenu"
        router
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
      >
        <el-menu-item index="/dashboard">
          <el-icon><Odometer /></el-icon>
          <span>数据概览</span>
        </el-menu-item>
        
        <el-sub-menu index="/users">
          <template #title>
            <el-icon><User /></el-icon>
            <span>用户管理</span>
          </template>
          <el-menu-item index="/users">用户列表</el-menu-item>
          <el-menu-item index="/user-levels">会员等级</el-menu-item>
        </el-sub-menu>
        
        <el-sub-menu index="/handcopy">
          <template #title>
            <el-icon><Document /></el-icon>
            <span>手抄报管理</span>
          </template>
          <el-menu-item index="/handcopy">手抄报列表</el-menu-item>
          <el-menu-item index="/handcopy-audit">审核管理</el-menu-item>
          <el-menu-item index="/handcopy-category">分类管理</el-menu-item>
        </el-sub-menu>
        
        <el-sub-menu index="/print">
          <template #title>
            <el-icon><Printer /></el-icon>
            <span>打印服务</span>
          </template>
          <el-menu-item index="/print-orders">打印订单</el-menu-item>
          <el-menu-item index="/print-price">价格设置</el-menu-item>
        </el-sub-menu>
        
        <el-sub-menu index="/shop">
          <template #title>
            <el-icon><Goods /></el-icon>
            <span>商城管理</span>
          </template>
          <el-menu-item index="/products">商品管理</el-menu-item>
          <el-menu-item index="/product-category">商品分类</el-menu-item>
          <el-menu-item index="/orders">订单管理</el-menu-item>
        </el-sub-menu>
        
        <el-menu-item index="/integral">
          <el-icon><Coin /></el-icon>
          <span>积分记录</span>
        </el-menu-item>
        
        <el-menu-item index="/recharge">
          <el-icon><Money /></el-icon>
          <span>充值管理</span>
        </el-menu-item>
        
        <el-menu-item index="/banners">
          <el-icon><Picture /></el-icon>
          <span>轮播图管理</span>
        </el-menu-item>
        
        <el-sub-menu index="/home-manage">
          <template #title>
            <el-icon><Grid /></el-icon>
            <span>首页管理</span>
          </template>
          <el-menu-item index="/home-modules">模块管理</el-menu-item>
          <el-menu-item index="/promotion-tags">促销标签</el-menu-item>
        </el-sub-menu>
        
        <el-menu-item index="/stores">
          <el-icon><Shop /></el-icon>
          <span>门店管理</span>
        </el-menu-item>
        
        <el-menu-item index="/settings">
          <el-icon><Setting /></el-icon>
          <span>系统设置</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    
    <el-container>
      <el-header class="header">
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="user-info">
              <el-icon><User /></el-icon>
              管理员
              <el-icon class="el-icon--right"><ArrowDown /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-header>
      
      <el-main class="main-content">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

export default {
  name: 'Layout',
  setup() {
    const route = useRoute()
    const router = useRouter()
    
    const activeMenu = computed(() => route.path)
    
    const handleCommand = (command) => {
      if (command === 'logout') {
        localStorage.removeItem('admin_token')
        ElMessage.success('退出成功')
        router.push('/login')
      }
    }
    
    return {
      activeMenu,
      handleCommand
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}
.sidebar {
  background: linear-gradient(180deg, #1a1f2e 0%, #243042 100%);
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);
}
.logo {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.15) 0%, rgba(102, 177, 255, 0.05) 100%);
}
.logo h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #fff 0%, #a8d4ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 1px 8px rgba(0, 21, 41, 0.06);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-bottom: 1px solid #f0f2f5;
}
.header-right {
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
}
.header-right:hover {
  background-color: #f5f7fa;
}
.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
  font-weight: 500;
}
.main-content {
  background: linear-gradient(135deg, #f5f7fa 0%, #eef1f6 100%);
  padding: 24px;
  min-height: calc(100vh - 60px);
}

/* 菜单样式优化 */
:deep(.el-menu) {
  background: transparent !important;
  padding: 8px 0;
}

:deep(.el-menu-item) {
  height: 48px;
  line-height: 48px;
  margin: 4px 12px;
  border-radius: 8px;
  color: #bfcbd9 !important;
  transition: all 0.2s ease;
}

:deep(.el-menu-item:hover) {
  background: rgba(64, 158, 255, 0.1) !important;
  color: #409EFF !important;
}

:deep(.el-menu-item.is-active) {
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%) !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

:deep(.el-sub-menu__title) {
  height: 48px;
  line-height: 48px;
  margin: 4px 12px;
  border-radius: 8px;
  color: #bfcbd9 !important;
  transition: all 0.2s ease;
}

:deep(.el-sub-menu__title:hover) {
  background: rgba(64, 158, 255, 0.1) !important;
  color: #409EFF !important;
}

:deep(.el-sub-menu.is-active .el-sub-menu__title) {
  color: #409EFF !important;
}
</style>
